import { Props } from './Layout'
import { useRouter } from 'next/router'
import { LocalStorageService } from '@/src/services/LocalStorageService'

export const useProps = (): Props => {
  const router = useRouter()

  return {
    email: LocalStorageService.loadEmailSignin() || LocalStorageService.loadEmailLogin(),
    onClickButton: () => router.back(),
  }
}
